/* ==========================================================================
   bed199-lazy-video
   Video lazy-load for the "6 Signs" bed listicle sections. mp4 sources sit in
   data-src and are promoted on intersection, matching the original static
   build. Guarded so the repeated <script> tag each media section emits only
   ever initialises once, and re-scanned on shopify:section:load so newly
   dropped sections work inside the theme editor.
   ========================================================================== */
(function () {
  if (window.__bed199LazyVideo) return;
  window.__bed199LazyVideo = true;

  var io = null;

  function load(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    v.load();
    var go = v.play();
    if (go && go.catch) {
      go.catch(function () {});
    }
  }

  function scan(root) {
    var vids = (root || document).querySelectorAll('video[data-bed199-lazy-video]');
    if (!('IntersectionObserver' in window)) {
      vids.forEach(load);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              load(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { rootMargin: '400px 0px' }
      );
    }
    vids.forEach(function (v) {
      if (!v.dataset.observed) {
        v.dataset.observed = '1';
        io.observe(v);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
